<template>
      <crud-delete :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @delete="remove"
                 @close="$emit('close')"
    >

        <v-card-text>
          <recargo-show-data :item="item" />
        </v-card-text>

        <v-card-text>
            <v-row justify="center">
                <span class="title">{{areYouSure}}</span>
            </v-row>
        </v-card-text>

    </crud-delete>
</template>

<script>
    //Provider  
    import RecargoProvider from "../../../providers/RecargoProvider";
    
    //Show Data
    import RecargoShowData from "../RecargoShow/RecargoShowData";
    
    //Common
    import {CrudDelete} from '@dracul/common-frontend'
import ClientError from "@/errors/ClientError";
    
    export default {
        name: "RecargoDelete",
        
        components: {RecargoShowData, CrudDelete},
        
        props: {
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },
        
        data() {
            return {
                modal: false,
                title: 'recargo.deleting',
                areYouSure: this.$t('common.areYouSureDeleteRecord'),
                errorMessage: '',
                loading: false,
            }
        },
        methods: {
            remove() {
                this.loading = true
                RecargoProvider.deleteRecargo(this.item.id).then(result => {
                            if (result.data.recargoDelete.success) {
                                this.$emit('itemDeleted',result.data.recargoDelete)
                                this.$emit('close')
                            }else{
                                this.errorMessage = 'Error on Delete'
                            }
                        }
                    ).catch(error =>{
                        let clientError = new ClientError(error)
                        this.errorMessage = clientError.showMessage
                }).finally(() => this.loading = false)
            },
        },
    }
</script>
